import { EventEmitter, Injectable, Type } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class WestnetzSidenavService {

    private _openRightnav = new EventEmitter<Type<any>>();
    private _closeRightnav = new EventEmitter<void>();

    constructor() {
    }

    public openRightnav(component: Type<any>) {
        this._openRightnav.emit(component);
    }

    public closeRightnav() {
        this._closeRightnav.emit();
    }

    public get openRightnav$(): Observable<Type<any>> {
        return this._openRightnav;
    }

    public get closeRightnav$(): Observable<void> {
        return this._closeRightnav;
    }

}
